// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer__TfAqK {
  font-size: 10px;
  line-height: 16px;
  color: #8c8c8c;
}
`, "",{"version":3,"sources":["webpack://./src/common/components/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".footer {\n  font-size: 10px;\n  line-height: 16px;\n  color: #8c8c8c;\n}\n"],"sourceRoot":""}]);
// Exports
export var footer = `footer__TfAqK`;
export default ___CSS_LOADER_EXPORT___;
